import axios from 'axios';

const baseURL = 'https://trendhopper-c3934b7293e6.herokuapp.com'; //  Base URL

// Generic error handling function
const handleResponse = async (response) => {
    if (!response.ok) {
        const errorData = await response.json(); // Try to parse JSON error
        const errorMessage = errorData.message || `HTTP error! Status: ${response.status}`;
        throw new Error(errorMessage);
    }
    return response.json();
};

export const saveUrl = async (url, userId) => {
    try {
        const response = await axios.post(`${baseURL}/create-blog/`, { url: url, user_id: userId }); // Corrected endpoint and parameter name
        return response.status === 200 || response.status === 201; // Check for both 200 and 201
    } catch (error) {
        console.error("Error in saveUrl:", error);
        return false;
    }
};

export const taskComplete = async (task_id) => {
    try {
        console.log('makingt he API call', task_id)
        const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/app/check-task-status/${task_id}`)
        console.log(response)
        return response.data; // Return the entire response data
    } catch (error) {
        console.error("Error in taskComplete:", error);
        throw new Error(error.message || 'An error occurred while checking task status');
    }
};

export const createDrafts = async (url, userId) => {
    try {
        console.log('makingt he API call')
        const response = await axios.post(`https://trendhopper-c3934b7293e6.herokuapp.com/create-drafts/`, { url, userId });
        console.log(response)
        return response.data; // Directly return the response data
    } catch (error) {
        console.error("Error in createDrafts:", error);
        throw new Error(error.message || 'An error occurred while creating drafts');
    }
};

export const fetchBlogDetails = async (url, userId) => {
    try {
        const response = await fetch(`${baseURL}/users/${userId}/blogurl/`, { // Corrected endpoint
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ url: url }), // URL in request body
        });

        return handleResponse(response); // Use generic error handling

    } catch (error) {
        console.error("Error in fetchBlogDetails:", error);
        throw error;
    }
};

export const acceptOnboarding = async (blogId, summary, keywords) => {
    try {
        const data = {
            summary: summary,
            keywords: keywords, // Array of keyword IDs
        };

        const response = await fetch(`${baseURL}/confirm-onboarding/${blogId}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        return handleResponse(response); // Use generic error handling

    } catch (error) {
        console.error("Error in acceptOnboarding:", error);
        throw error; // Re-throw the error to be caught by the component
    }
};
